import React from 'react';
import {useTranslation} from "react-i18next";

const AppPromo: React.FC = () => {
    const { t } = useTranslation() as {
        t: (key: string, options?: any) => string;
    };
  return (
    <div className="flex flex-col justify-between px-4 sm:px-8 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 items-center pt-8 md:py-12">
        {/* Изображение мобильного приложения */}
        <h2 className="block md:hidden text-3xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold mb-4 md:mb-6" dangerouslySetInnerHTML={{ __html: t('titleMobile') }}>
        </h2>

        <div className="w-11/12 sm:w-3/5 md:w-2/4 rounded mx-auto">
            <img 
              src={require(`../../assets/images/${t('phone_products_image')}.png`)}
              alt="Работаем 8 лет"
              className="w-full h-auto"
            />
        </div>
        
        <div className="mt-8 md:mt-0 text-center md:text-left">
          <h2 className="hidden md:block text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl font-bold mb-4 md:mb-6" dangerouslySetInnerHTML={{ __html: t('title') }}>

          </h2>
          <p className="text-left text-3xl md:text-4xl lg:text-4xl mb-4 md:mb-6 " dangerouslySetInnerHTML={{ __html: t('description') }}>

          </p>
        </div>
      </div>
    </div>
  );
};

export default AppPromo;
